import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

const url = new URL (location.href);
const { hostname, pathname } = url;

if (hostname === 'abuse.sav.com' && !pathname.startsWith('/sav')) {
  window.location.href = `//abuse.sav.com/sav`;
}
else if (hostname === 'abuse.nominet.uk' && !pathname.startsWith('/nominet')) {
  window.location.href = '//abuse.nominet.uk/nominet';
}

const prefix = hostname.match(/^(.*?)[-.]abuse\.cleandns\.space/);
if (prefix) {
  window.location.href = `//abuse.cleandns.space/${prefix[1]}`;
}


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
